import React, { useRef, useState } from "react";

const offers = [
  { src: "/img/r1.jpeg",  alt: "Crompton Wave Plus Table Fan ₹2,450" },
  { src: "/img/r2.jpeg",  alt: "Orient Desk 25 Table Fan ₹2,450" },
  { src: "/img/r3.jpeg",  alt: "Lakshmi Aeromax Tower Fan ₹2,299" },
  { src: "/img/r4.jpeg",  alt: "HTC Hair Clipper AT-118 ₹400" },
  { src: "/img/r5.jpeg",  alt: "HTC Hair Trimmer AT-539 ₹630" },
  { src: "/img/r6.jpeg",  alt: "TV Remote Combo ₹95" },
  { src: "/img/r7.jpeg",  alt: "Auto Lock Bike Lock ₹100" },
  { src: "/img/r8.jpeg",  alt: "Aro-Flex Wire Coil ₹1,350" },
  { src: "/img/r9.jpeg",  alt: "Aro-Flex Wire Coil ₹1,350" },
  { src: "/img/r10.jpeg",  alt: "Aro-Flex Wire Coil ₹1,350" },
  { src: "/img/r11.jpeg",  alt: "Aro-Flex Wire Coil ₹1,350" },
];

// Duplicate for seamless loop
const doubled = [...offers, ...offers];

export const Offers = () => {
  const trackRef = useRef(null);
  const [paused, setPaused] = useState(false);

  return (
    <section id="offers">
      <div className="offers-header text-center">
        <h2>
  <span>Special Offers</span>
</h2>
<hr style={{ margin: "0 auto 20px", width: "70px" }} />
<p>சிறப்பு சலுகைகள் — Limited Stock · Hurry Up!</p>
      </div>

      <div
        className="offers-slider"
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
      >
        <div
          ref={trackRef}
          className={`offers-track ${paused ? "paused" : ""}`}
        >
          {doubled.map((offer, i) => (
            <div className="offer-slide" key={i}>
              <img
                src={offer.src}
                alt={offer.alt}
                className="offer-slide-img"
                onError={(e) => { e.target.style.display = "none"; }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};